'use strict';

/*jslint bitwise: true */
angular.module('ntmApp')
  .filter('durationSplit', ['Constants', function (Constants) {

      return function (input, formatType) {

          if (angular.isNumber(input)) {

              var sighn = Math.sign(input);

              var allMinuteTime = parseFloat(Math.abs(input));

              var hours = Math.floor(allMinuteTime / 60);

              var minutes = Math.floor(allMinuteTime - hours * 60);

              var seconds = Math.round((allMinuteTime - ((hours * 60) + minutes)) * 60);

              if (minutes === 60) { hours += 1; minutes = 0; }

              if (seconds === 60) { minutes += 1; seconds = 0; }

              var result = "";

              switch (formatType) {
                  case Constants.DurationSplitFormats.HMS:
                      result = '{0}h {1}m {2}s'.format(sighn * hours, minutes, seconds);
                      break;

                  case Constants.DurationSplitFormats.HM:
                      result = '{0}h {1}m'.format(sighn * hours, minutes);
                      break;

                  case Constants.DurationSplitFormats.HMMid:
                      result = '{0}hr {1}min'.format(sighn * hours, minutes);
                      break;

                  case Constants.DurationSplitFormats.HMLong:
                      result = '{0}hours {1}minutes'.format(sighn * hours, minutes);
                      break;

                  case Constants.DurationSplitFormats.HShort:
                      result = '{0}h'.format((sighn * allMinuteTime / 60).toFixed(2));
                      break;

                  case Constants.DurationSplitFormats.Hlong:
                      result = '{0}hours'.format((sighn * allMinuteTime / 60).toFixed(2));
                      break;

                  default:
                      result = '{0}hr {1}min'.format(sighn * hours, minutes);
              }

              return result;
          }

          return input;
      };
  }]);